import { ACTIVE_NAV } from './actionTypes';
export const setActiveNav = obj => {
  return {
    type: ACTIVE_NAV,
    payload: obj,
  };
};
